import { format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';

const FormatDate = (value, timeFormat = 'dd MMMM yyyy') => {
    if (value === null || value === undefined || value === '') return '';

    let dateObj;
    if (value instanceof Date) {
        dateObj = value;
    } else if (typeof value === 'number') {
        // Assume number is epoch in milliseconds
        dateObj = new Date(value);
    } else if (typeof value === 'string') {
        const trimmed = value.trim();
        if (/^\d+$/.test(trimmed)) {
            const num = Number(trimmed);
            const ms = trimmed.length === 10 ? num * 1000 : num;
            dateObj = new Date(ms);
        } else {
            // Date string
            dateObj = new Date(trimmed);
        }
    } else {
        return '';
    }

    if (isNaN(dateObj)) return '';

    const timeZone = 'Asia/Jakarta';
    const zonedDate = utcToZonedTime(dateObj, timeZone);

    return format(zonedDate, timeFormat);
};

export default FormatDate;
